import dayjs from 'dayjs'
export default {
    convertDate(timeStr)
    {
        return dayjs(timeStr).toDate()
    },

    //获取当前时间
    getCurrentTime() {
       return (dayjs().format('YYYY-MM-DD HH:mm:ss'))
    },
    //获取当前日期
    getCurrnetDay() {
        return (dayjs().format('YYYY-MM-DD'))
    },
    //今日是否在传入日期前
    isBeforeDay(time)
    {
        return dayjs().isBefore(dayjs(time))
    },
    //unix 标准格式
    getUnixStander(time){
        return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
        
    },
}